<template>
  <article class="layout-section">
    <h2 v-appear:left="{ delay: 150 }" class="layout-section__title -mobile">{{ $t('home.testimonies.title') }}</h2>

    <section class="layout-section__flex -center">
      <div v-appear:left="{ delay: 150, threshold: 0.25 }" class="layout-section__split -half">
        <transition name="fade-in-out" mode="out-in">
          <figure :key="currentImage" class="layout-section__figure -large" :style="{ '--image': currentImage }" />
        </transition>

        <h2 class="layout-section__title -alt">{{ $t('home.testimonies.title') }}</h2>
      </div>

      <div class="layout-section__split">
        <blockquote v-appear="{ delay: 175 }" class="section-box" :style="boxHeight">
          <div ref="box" class="section-box__content">
            <transition name="fade-down" mode="out-in" @enter="updateHeight">
              <p :key="currentContent" v-appear:down="{ delay: 225 }">“{{ currentContent }}”</p>
            </transition>

            <transition name="fade-up" mode="out-in">
              <div :key="currentName" v-appear:down="{ delay: 350 }">
                <p class="section-box__bottom">{{ currentName }}</p>
              </div>
            </transition>
          </div>
        </blockquote>
      </div>
    </section>

    <div class="image-loader">
      <img v-for="testimony in testimonies" :key="testimony.image" :src="testimony.image" />
    </div>
  </article>
</template>

<script>
export default {
  name: 'HomeTestimonies',
  data() {
    return {
      currentIndex: 0,
      interval: null,
      height: 0
    }
  },
  computed: {
    boxHeight() {
      return this.height ? { '--content-height': `${this.height}px` } : 'auto'
    },
    testimonies() {
      return this.$t('home.testimonies.slides')
    },
    currentContent() {
      return this.testimonies[this.currentIndex].content
    },
    currentName() {
      return this.testimonies[this.currentIndex].name
    },
    currentImage() {
      return `url('${this.testimonies[this.currentIndex].image}')`
    }
  },
  created() {
    this.interval = setInterval(this.nextSlide, 6500)
  },
  mounted() {
    this.updateHeight()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.testimonies.length
    },
    updateHeight() {
      setTimeout(() => {
        if (!this.$refs.box) return
        this.height = this.$refs.box.clientHeight
      }, 50)
    }
  }
}
</script>
